import React from 'react';
import { FormattedMessage } from 'react-intl';

import { LoginPageMessages } from '../messages';
import { SocialProvider } from '../../../types';
import Heading from '@atlaskit/heading';

const Header = ({
  highlightedSocialProvider,
  showSocialLoginOnly,
}: {
  highlightedSocialProvider: SocialProvider | null;
  showSocialLoginOnly: boolean | null;
}) => {
  if (showSocialLoginOnly) {
    return (
      <Heading size="small" as="h1">
        <FormattedMessage
          {...LoginPageMessages.socialFormTitle}
          values={{
            socialProviderName: highlightedSocialProvider?.replace(/^./, str => str.toUpperCase()),
          }}
        />
      </Heading>
    );
  }

  return (
    <Heading size="small" as="h1">
      <FormattedMessage {...LoginPageMessages.headTitle} />
    </Heading>
  );
};

export default Header;
